export const getFileExtension = (filename: string): string => {
  const lastIndex = filename.lastIndexOf(".");
  if (lastIndex === -1) {
    return ""; // No extension found
  }
  return filename.slice(lastIndex + 1);
};
